import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function Planes() {
    const [plans, setPlans] = useState([]);
    const [creating, setCreating] = useState(false);
    const [form, setForm] = useState({
        name: "",
        coin_allocation: 1000,
        price_usd: 100,
        expires_at: "",
    });

    async function load() {
        const r = await api.get("/ejecutivo/plans");
        setPlans(r.data || []);
    }
    useEffect(() => {
        load();
    }, []);

    async function create() {
        await api.post("/ejecutivo/plans", form);
        toast.success("Plan creado");
        setCreating(false);
        load();
    }

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="planes-page">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-3xl font-semibold">Planes y Monedas</h1>
                <button
                    onClick={() => setCreating(true)}
                    className="edu-btn-primary px-4 py-2.5 text-sm inline-flex items-center gap-2"
                >
                    <Plus size={14} /> Nuevo Plan
                </button>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                {plans.map((p) => (
                    <div key={p.id} className="edu-card p-6">
                        <h3 className="text-xl font-semibold">{p.name}</h3>
                        <div className="text-3xl font-bold text-edu-navy mt-2">${p.price_usd}</div>
                        <p className="text-sm text-edu-body mt-1">{p.coin_allocation} monedas</p>
                        <p className="text-xs text-edu-muted mt-3">Expira: {p.expires_at || "—"}</p>
                    </div>
                ))}
            </div>
            {creating && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
                    <div className="edu-card p-6 max-w-md w-full">
                        <div className="flex justify-between mb-4">
                            <h3 className="text-xl font-semibold">Nuevo Plan</h3>
                            <button onClick={() => setCreating(false)}>
                                <X size={18} />
                            </button>
                        </div>
                        <div className="space-y-3">
                            <input
                                placeholder="Nombre"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                className="edu-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Monedas asignadas"
                                value={form.coin_allocation}
                                onChange={(e) =>
                                    setForm({ ...form, coin_allocation: parseInt(e.target.value || "0", 10) })
                                }
                                className="edu-input w-full"
                            />
                            <input
                                type="number"
                                placeholder="Precio USD"
                                value={form.price_usd}
                                onChange={(e) =>
                                    setForm({ ...form, price_usd: parseFloat(e.target.value || "0") })
                                }
                                className="edu-input w-full"
                            />
                            <input
                                type="date"
                                value={form.expires_at}
                                onChange={(e) => setForm({ ...form, expires_at: e.target.value })}
                                className="edu-input w-full"
                            />
                            <button onClick={create} className="edu-btn-primary w-full py-2.5 text-sm">
                                Crear
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
